import { configureStore } from "@reduxjs/toolkit";
import { individualApplicationApi } from "IndividualApplication";
import { reducer as formReducer } from "redux-form";

import { modalReducer } from "Cobalt/Modal";
import { abTestReducer } from "Common/abTestUtils/redux";

import { accountApi } from "Care/features/account";

export const reducerSlices = {
  form: formReducer,
  abTests: abTestReducer,
  openModal: modalReducer,
  [individualApplicationApi.reducerPath]: individualApplicationApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(individualApplicationApi.middleware).concat(accountApi.middleware),
    preloadedState,
  });

  return store;
};
